import { useSelector } from 'react-redux';

/**
 * Hook personnalisé pour vérifier si l'utilisateur actuellement connecté
 * possède une permission spécifique.
 * @param {string} requiredPermission - Le nom de la permission à vérifier (ex: 'reports:view').
 * @returns {boolean} - True si l'utilisateur a la permission, sinon false.
 */
export const useHasPermission = (requiredPermission) => {
  const userPermissions = useSelector((state) => state.signin.user?.permissions);

  if (!requiredPermission) {
    return false;
  }

  if (!Array.isArray(userPermissions)) {
    return false;
  }

  return userPermissions.includes(requiredPermission);
};